import { apiFetch } from "./api";

export interface BackendUser {
  id: string;
  email: string;
  username: string | null;
  name: string;
  roleType: string;
  roleLabel: string | null;
  department: string | null;
  phone: string | null;
  tenantId: string | null;
  status: string;
  lastLoginAt: string | null;
}

export interface UpdateMeBody {
  name?: string;
  phone?: string;
  department?: string;
}

export const authApi = {
  updateMe: (body: UpdateMeBody) =>
    apiFetch<{ user: BackendUser }>("/auth/me", { method: "PATCH", body }),

  // Password change is handled by Clerk's UserProfile widget — no
  // backend endpoint to call. Keep the API surface tight so accidental
  // imports fail loudly.
};
